import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://qeaxdhsuptsajyugqtjq.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFlYXhkaHN1cHRzYWp5dWdxdGpxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxNjQ0NDksImV4cCI6MjA2Nzc0MDQ0OX0.u8VqxvMU51H9mCIlWrCHiuGagmOSnVrzL5SjxS1_bwk';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipos para TypeScript
export interface User {
  id: string;
  email: string;
  name?: string;
  wallet_address?: string;
  seed_phrase?: string;
  created_at: string;
  updated_at: string;
}

export interface Wallet {
  id: string;
  user_id: string;
  address: string;
  type: string;
  balance: number;
  created_at: string;
} 